import React from 'react';
import { useTranslation } from 'react-i18next';
import PreloaderComponent from '../../commons/preloader/preloaderComponent';
import Moment from 'moment';
import './publicAnnouncementList.css';
import { Alert } from 'react-bootstrap';

const PublicAnnouncementListView = ({
    announcements,
    isLoading,
    onAnnouncementClick,
    message,
    success,
}) => {
    const { t } = useTranslation();
    return (
        <div className="announcements">
            <div className="title-row">
                <h2>{t('announcements.title')}</h2>
            </div>

            {message && !success ? (
                <Alert variant={!success ? 'danger' : 'success'}>
                    {t(message.key, message.params)}
                </Alert>
            ) : null}
            {isLoading && <PreloaderComponent />}
            {!isLoading && announcements && announcements.length === 0 && (
                <p>{t('announcements.none')}</p>
            )}
            {!isLoading &&
                announcements &&
                announcements.map((announcement) => {
                    return (
                        <div
                            key={announcement.id}
                            className="single-announcement"
                            onClick={() => onAnnouncementClick(announcement.id)}
                        >
                            <div className="single-announcement-details">
                                <h5>
                                    {announcement.titleFI} /{' '}
                                    {announcement.titleEN}
                                </h5>
                                <p>
                                    {t('announcements.published', {
                                        date: Moment(
                                            announcement.publishedAt
                                        ).format('D.M.YYYY'),
                                    })}
                                </p>
                            </div>
                        </div>
                    );
                })}
        </div>
    );
};

export default PublicAnnouncementListView;
